import React, { createContext, useContext, useState } from 'react';

// create a context with a default value of an empty object
const AssessmentTokenContext = createContext({
	assessmentId: '',
	assessmentToken: '',
	setAssessmentToken: () => {},
	setAssessmentId: () => {},
	redirectionPath: '',
	setRedirectionPath: () => {},
	selectedRoadmapPublishedItemId: '',
	setSelectedRoadmapPublishedItemId: () => {},
	isKnowYourLevelAssessmentGiven: false,
	setIsKnowYourLevelAssessmentGiven: () => {},
} as {
	assessmentId: string;
	setAssessmentId: React.Dispatch<React.SetStateAction<any>>;
	assessmentToken: string;
	setAssessmentToken: React.Dispatch<React.SetStateAction<any>>;
	redirectionPath: string;
	setRedirectionPath: React.Dispatch<React.SetStateAction<any>>;
	selectedRoadmapPublishedItemId: string;
	setSelectedRoadmapPublishedItemId: React.Dispatch<React.SetStateAction<any>>;
	isKnowYourLevelAssessmentGiven: boolean;
	setIsKnowYourLevelAssessmentGiven: React.Dispatch<React.SetStateAction<any>>;
});

// provide a provider component for the context
export const AssessmentTokenProvider = ({ children }: { children: React.ReactNode }) => {
	const [assessmentId, setAssessmentId] = useState('');
	const [assessmentToken, setAssessmentToken] = useState('');
	const [redirectionPath, setRedirectionPath] = useState('');
	const [isKnowYourLevelAssessmentGiven, setIsKnowYourLevelAssessmentGiven] = useState(false);

	const [selectedRoadmapPublishedItemId, setSelectedRoadmapPublishedItemId] = useState('');
	return (
		<AssessmentTokenContext.Provider
			value={{
				selectedRoadmapPublishedItemId,
				setSelectedRoadmapPublishedItemId,
				redirectionPath,
				setRedirectionPath,
				assessmentId,
				setAssessmentId,
				assessmentToken,
				setAssessmentToken,
				isKnowYourLevelAssessmentGiven,
				setIsKnowYourLevelAssessmentGiven,
			}}
		>
			{children}
		</AssessmentTokenContext.Provider>
	);
};

// custom hook to use the context
export const useAssessmentToken = () => {
	const context = useContext(AssessmentTokenContext);
	if (context === undefined) {
		throw new Error('useAssessmentToken must be used within a AssessmentTokenProvider');
	}
	return context;
};
